import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useProcessLogDetail(id, params) {
  return useSWR(
    !id
      ? null
      : {
          path: `/api/v1/process-logs/${id}`,
          method: "GET",
          params,
        },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useProcessLogDetail;
